/**
 * KvK levert het land van een adres als naam uit de BRP-landentabel (Tabel 34), niet als ISO-code:
 * een Duits adres komt binnen als "Bondsrepubliek Duitsland". Deze tabel vertaalt die namen naar de
 * alpha2-codes uit onze landenlijst.
 *
 * `null` staat voor een historisch of samengesteld gebied zonder één opvolger (Sovjet-Unie,
 * Nederlandse Antillen, Korea, ...) en voor Kosovo, waarvoor `XK` een user-assigned code is die niet
 * in onze landenlijst zit. Die laten we bewust leeg: het formulier dwingt de gebruiker dan zelf een
 * land te kiezen, wat beter is dan stilzwijgend het verkeerde land vastleggen.
 */
export const countryByBrpName: Record<string, string | null> = {
    Abessinië: 'ET',
    'Aboe Dhabi': 'AE',
    Aden: 'YE',
    Afghanistan: 'AF',
    Ajman: 'AE',
    Albanië: 'AL',
    Algerije: 'DZ',
    'Amerikaans Samoa': 'AS',
    'Amerikaanse Maagdeneilanden': 'VI',
    Andorra: 'AD',
    Angola: 'AO',
    Anguilla: 'AI',
    Antigua: 'AG',
    'Antigua en Barbuda': 'AG',
    Argentinië: 'AR',
    Armenië: 'AM',
    Aruba: 'AW',
    Ascension: 'SH',
    'Australisch Nieuw-Guinea': 'PG',
    'Australische Salomonseilanden': 'SB',
    Australië: 'AU',
    Azerbeidzjan: 'AZ',
    Azoren: 'PT',
    "Bahama's": 'BS',
    Bahrein: 'BH',
    Bangladesh: 'BD',
    Barbados: 'BB',
    Basoetoland: 'LS',
    Bechuanaland: 'BW',
    Belarus: 'BY',
    Belau: 'PW',
    'Belgisch Congo': 'CD',
    België: 'BE',
    Belize: 'BZ',
    Benin: 'BJ',
    Bermuda: 'BM',
    Bhutan: 'BT',
    Bolivia: 'BO',
    'Bondsrepubliek Duitsland': 'DE',
    'Bosnië-Herzegovina': 'BA',
    Botswana: 'BW',
    Brazilië: 'BR',
    'Brits Afrika': null,
    'Brits Guyana': 'GY',
    'Brits Honduras': 'BZ',
    'Brits Indië': 'IN',
    'Brits Kameroen': 'CM',
    'Brits Noordborneo': 'MY',
    'Brits Oost-Afrika': 'KE',
    'Brits Somaliland': 'SO',
    'Brits Territ. in Antarctica': 'AQ',
    'Brits Territorium in de Indische Oceaan': 'IO',
    'Brits West-Indië': null,
    'Brits Westborneo': 'MY',
    'Brits-Borneo': 'MY',
    'Britse Antillen': null,
    'Britse Maagdeneilanden': 'VG',
    'Britse Salomons-eilanden': 'SB',
    Brunei: 'BN',
    Bulgarije: 'BG',
    'Burkina Faso': 'BF',
    Burma: 'MM',
    Burundi: 'BI',
    Cabinda: 'AO',
    Caicoseilanden: 'TC',
    Cambodja: 'KH',
    Canada: 'CA',
    'Canarische Eilanden': 'ES',
    'Canton en Enderbury': 'KI',
    'Caribisch Nederland': 'BQ',
    Caymaneilanden: 'KY',
    'Centraal-Afrikaanse Republiek': 'CF',
    Ceylon: 'LK',
    Chili: 'CL',
    China: 'CN',
    Christmaseiland: 'CX',
    Cocoseilanden: 'CC',
    Colombia: 'CO',
    Comoren: 'KM',
    Congo: 'CG',
    Cookeilanden: 'CK',
    'Costa Rica': 'CR',
    Cuba: 'CU',
    Curaçao: 'CW',
    Cyprus: 'CY',
    Dahomey: 'BJ',
    Dantzig: 'PL',
    'Democratische Republiek Congo': 'CD',
    Denemarken: 'DK',
    Djibouti: 'DJ',
    Doebai: 'AE',
    Dominica: 'DM',
    'Dominicaanse Republiek': 'DO',
    'Duits Oost-Afrika': 'TZ',
    'Duits Zuidwest-Afrika': 'NA',
    'Duitse Democratische Republiek': 'DE',
    Duitsland: 'DE',
    Ecuador: 'EC',
    Egypte: 'EG',
    'El Salvador': 'SV',
    'Equatoriaal-Guinea': 'GQ',
    Eritrea: 'ER',
    Estland: 'EE',
    Ethiopië: 'ET',
    Faeröer: 'FO',
    Falklandeilanden: 'FK',
    'Federale Republiek Joegoslavie': null,
    Fiji: 'FJ',
    Filipijnen: 'PH',
    Finland: 'FI',
    Foedjaira: 'AE',
    Frankrijk: 'FR',
    'Frans Afar en Issa gebied': 'DJ',
    'Frans Congo': 'CG',
    'Frans Equatoriaal-Afrika': null,
    'Frans Indie': 'IN',
    'Frans Indo China': null,
    'Frans Kameroen': 'CM',
    'Frans Somaliland': 'DJ',
    'Frans West Afrika': null,
    'Frans-Guyana': 'GF',
    'Frans-Polynesië': 'PF',
    Gabon: 'GA',
    Gambia: 'GM',
    Georgië: 'GE',
    Ghana: 'GH',
    Gibraltar: 'GI',
    'Gilbert- en Ellice Eilanden': null,
    Gilberteilanden: 'KI',
    Goa: 'IN',
    Goudkust: 'GH',
    Grenada: 'GD',
    Griekenland: 'GR',
    Groenland: 'GL',
    Guadeloupe: 'GP',
    Guam: 'GU',
    Guatemala: 'GT',
    Guinee: 'GN',
    'Guinee-Bissau': 'GW',
    Guyana: 'GY',
    'Hawaii-eilanden': 'US',
    Haïti: 'HT',
    Honduras: 'HN',
    Hongarije: 'HU',
    Hongkong: 'HK',
    Ierland: 'IE',
    Ifni: 'MA',
    IJsland: 'IS',
    India: 'IN',
    Indochina: null,
    Indonesië: 'ID',
    'Internationaal Gebied': null,
    Irak: 'IQ',
    Iran: 'IR',
    'Isle of Man': 'IM',
    Israël: 'IL',
    'Italiaans Somaliland': 'SO',
    Italië: 'IT',
    Ivoorkust: 'CI',
    Jamaica: 'JM',
    Japan: 'JP',
    Jemen: 'YE',
    Joegoslavië: null,
    'Johnston-atol': 'UM',
    Johore: 'MY',
    Jordanië: 'JO',
    'Kaapverdische Eilanden': 'CV',
    Kaapverdië: 'CV',
    'Kaiser Wilhelmsland': 'PG',
    Kameroen: 'CM',
    Kanaaleilanden: null,
    Kasjmir: null,
    Kazachstan: 'KZ',
    Kedah: 'MY',
    Kelantan: 'MY',
    Kenia: 'KE',
    'Kirgizische Republiek': 'KG',
    Kiribati: 'KI',
    Koeweit: 'KW',
    'Kongo Brazzaville': 'CG',
    'Kongo Kinshasa': 'CD',
    Korea: null,
    Kosovo: null,
    Kroatië: 'HR',
    Labuan: 'MY',
    Laos: 'LA',
    Leeuwardeilanden: null,
    Lesotho: 'LS',
    Letland: 'LV',
    Libanon: 'LB',
    Liberia: 'LR',
    Libië: 'LY',
    Liechtenstein: 'LI',
    Litouwen: 'LT',
    Luxemburg: 'LU',
    Macau: 'MO',
    Macedonië: 'MK',
    Madagaskar: 'MG',
    'Madeira-eilanden': 'PT',
    Malakka: 'MY',
    Malawi: 'MW',
    Maldiven: 'MV',
    Maleisië: 'MY',
    Mali: 'ML',
    Malta: 'MT',
    Marianen: 'MP',
    Marokko: 'MA',
    Marshalleilanden: 'MH',
    Martinique: 'MQ',
    Mauritanië: 'MR',
    Mauritius: 'MU',
    Mayotte: 'YT',
    Mexico: 'MX',
    Micronesia: 'FM',
    Midway: 'UM',
    Moldavië: 'MD',
    Monaco: 'MC',
    Mongolië: 'MN',
    Montenegro: 'ME',
    Montserrat: 'MS',
    Mozambique: 'MZ',
    'Muscat en Oman': 'OM',
    Myanmar: 'MM',
    Namibië: 'NA',
    Nauru: 'NR',
    Nederland: 'NL',
    'Nederlands Nieuw-Guinea': 'ID',
    'Nederlands-Indië': 'ID',
    'Nederlandse Antillen': null,
    'Negri Sembilan': 'MY',
    Nepal: 'NP',
    Newfoundland: 'CA',
    Nicaragua: 'NI',
    'Nieuw-Caledonië': 'NC',
    'Nieuw-Zeeland': 'NZ',
    'Nieuwe Hebriden': 'VU',
    Niger: 'NE',
    Nigeria: 'NG',
    Niue: 'NU',
    'Noord-Jemen': 'YE',
    'Noord-Korea': 'KP',
    'Noord-Vietnam': 'VN',
    Noordrhodesie: 'ZM',
    Noorwegen: 'NO',
    Norfolk: 'NF',
    Nyasaland: 'MW',
    Oeganda: 'UG',
    Oekraïne: 'UA',
    'Oem el Koewein': 'AE',
    Oeroendi: 'BI',
    Oezbekistan: 'UZ',
    Oman: 'OM',
    Onbekend: null,
    'Oost-Timor': 'TL',
    Oostenrijk: 'AT',
    'Oostenrijk-Hongarije': null,
    'Opper-Volta': 'BF',
    'Pacific eilanden': null,
    Pahang: 'MY',
    Pakistan: 'PK',
    Palau: 'PW',
    Palestina: 'PS',
    Panama: 'PA',
    Panamakanaalzone: 'PA',
    'Papoea-Nieuw-Guinea': 'PG',
    Paraguay: 'PY',
    Perak: 'MY',
    Perlis: 'MY',
    Peru: 'PE',
    Phoenixeilanden: 'KI',
    Pitcairneilanden: 'PN',
    Polen: 'PL',
    Portugal: 'PT',
    'Portugees Afrika': null,
    'Portugees Guinee': 'GW',
    'Portugees Indie': 'IN',
    'Portugees Oost Afrika': 'MZ',
    'Portugees Timor': 'TL',
    'Portugees West Afrika': 'AO',
    'Puerto Rico': 'PR',
    Qatar: 'QA',
    'Ras-El-Cheima': 'AE',
    Rhodesië: 'ZW',
    Roemenië: 'RO',
    'Ruanda-Urundi': null,
    'Rusland (oud)': 'RU',
    'Russische Federatie': 'RU',
    Rwanda: 'RW',
    Ryukyueilanden: 'JP',
    Réunion: 'RE',
    Saarland: 'DE',
    Sabah: 'MY',
    'Saint Kitts en Nevis': 'KN',
    'Saint Kitts-Nevis-Anguilla': null,
    'Saint Vincent en de Grenadines': 'VC',
    'Saint-Pierre en Miquelon': 'PM',
    Salomonseilanden: 'SB',
    Samoa: 'WS',
    'San Marino': 'SM',
    'Sao Tomé en Principe': 'ST',
    'Saoedi-Arabië': 'SA',
    Sarawak: 'MY',
    Selangor: 'MY',
    Senegal: 'SN',
    Servië: 'RS',
    'Servië en Montenegro': null,
    Seychellen: 'SC',
    'Seychellen en Amiranten': 'SC',
    Siam: 'TH',
    'Sierra Leone': 'SL',
    Sikkim: 'IN',
    Singapore: 'SG',
    'Sint Lucia': 'LC',
    'Sint Maarten': 'SX',
    'Sint Vincent': 'VC',
    'Sint-Helena': 'SH',
    Sjardja: 'AE',
    Slovenië: 'SI',
    Slowakije: 'SK',
    Soedan: 'SD',
    Somalië: 'SO',
    'Sovjet-Unie': null,
    'Spaans Guinee': 'GQ',
    'Spaans Noord-Afrika': 'ES',
    'Spaanse Sahara': 'EH',
    Spanje: 'ES',
    Spitsbergen: 'SJ',
    'Sri Lanka': 'LK',
    'Straits Settlements': null,
    Suriname: 'SR',
    Svalbardeilanden: 'SJ',
    Swaziland: 'SZ',
    Syrië: 'SY',
    Tadzjikistan: 'TJ',
    Taiwan: 'TW',
    Tanganyika: 'TZ',
    Tanzania: 'TZ',
    Tasmanie: 'AU',
    Thailand: 'TH',
    Tibet: 'CN',
    'Tijdelijk: Migratie': null,
    Togo: 'TG',
    'Tokelau-eilanden': 'TK',
    Tonga: 'TO',
    Transjordanie: 'JO',
    Trengganu: 'MY',
    'Trinidad en Tobago': 'TT',
    'Tristan Da Cunha': 'SH',
    'Trucial Oman': 'AE',
    Tsjaad: 'TD',
    Tsjechië: 'CZ',
    Tsjechoslowakije: null,
    Tunesië: 'TN',
    Turkije: 'TR',
    Turkmenistan: 'TM',
    'Turks- en Caicoseilanden': 'TC',
    Turkseilanden: 'TC',
    Tuvalu: 'TV',
    Uruguay: 'UY',
    Vanuatu: 'VU',
    Vaticaanstad: 'VA',
    Venezuela: 'VE',
    'Verenigd Koninkrijk': 'GB',
    'Verenigde Arabische Emiraten': 'AE',
    'Verenigde Arabische Republiek': 'EG',
    'Verenigde Staten van Amerika': 'US',
    Vietnam: 'VN',
    'Wake-eiland': 'UM',
    'Wallis en Futuna': 'WF',
    'West-Samoa': 'WS',
    'Westelijke Sahara': 'EH',
    Windwardeilanden: null,
    Zambia: 'ZM',
    Zanzibar: 'TZ',
    Zaïre: 'CD',
    Zimbabwe: 'ZW',
    'Zuid-Afrika': 'ZA',
    'Zuid-Jemen': 'YE',
    'Zuid-Korea': 'KR',
    'Zuid-Soedan': 'SS',
    'Zuid-Vietnam': 'VN',
    'Zuidarabische Federatie': 'YE',
    Zuidrhodesie: 'ZW',
    'Zuidwest Afrika': 'NA',
    Zweden: 'SE',
    Zwitserland: 'CH',
}

/** Diakrieten en hoofdletters weg, zodat kleine schrijfwijzeverschillen de lookup niet breken. */
const normalize = (value: string): string =>
    value
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()

const countryByNormalizedName = new Map<string, string | null>(Object.entries(countryByBrpName).map(([name, alpha2]) => [normalize(name), alpha2]))

/**
 * Zet een KvK-landnaam om in een alpha2-code. Geeft `undefined` bij een lege naam, bij een gebied
 * zonder eenduidige opvolger, en bij een naam die niet in de tabel staat — de KvK-documentatie
 * meldt zelf dat er in uitzonderingsgevallen van de tabel wordt afgeweken.
 */
export function resolveKvkCountry(land?: string): string | undefined {
    if (!land?.trim()) {
        return undefined
    }

    return countryByNormalizedName.get(normalize(land)) ?? undefined
}
